import { UsersFormData } from '@/types/usersFormData'
import {
  isHalfWidthAlphaNumeric,
  isHalfWidthAlphaNumericWithSymbols,
} from '@/utils/inputChecker'

export type ValidationErrors = Partial<Record<keyof UsersFormData, string>>

export const useUserValidation = () => {
  const validate = (
    formData: UsersFormData,
    id: string | undefined,
  ): ValidationErrors => {
    const newErrors: ValidationErrors = {}

    if (!formData.loginId) {
      newErrors.loginId = 'IDは必須です'
    } else if (!isHalfWidthAlphaNumericWithSymbols(formData.loginId)) {
      newErrors.loginId = 'IDは半角英数字と記号[@._+-]で入力してください'
    } else if (formData.loginId.length > 30) {
      newErrors.loginId = 'IDは30文字以内で入力してください'
    }
    if (!formData.name) {
      newErrors.name = 'アカウント名は必須です'
    } else if (formData.name.length > 50) {
      newErrors.name = 'アカウント名は50文字以内で入力してください'
    }

    if (!id && !formData.password) {
      newErrors.password = 'パスワードは必須です'
    } else if (
      formData.password &&
      !isHalfWidthAlphaNumeric(formData.password)
    ) {
      newErrors.password = 'パスワードは半角英数字で入力してください'
    } else if (
      formData.password &&
      (formData.password.length < 8 || formData.password.length > 20)
    ) {
      newErrors.password = 'パスワードは8文字以上20文字以内で入力してください'
    }
    if (!formData.role) {
      newErrors.role = '権限は必須です'
    }
    return newErrors
  }

  return { validate }
}
